import {SelectChangeEvent} from "../../../../common/ts/events/Events";
import {EventBus} from "../../../../common/ts/events/EventBus";

interface DropdownOptionSelectedEventDetail {
    textOptionSelected: string;
    optionSelected: string;
}

class DropdownOptionSelectedEvent extends CustomEvent<DropdownOptionSelectedEventDetail> {

    static type: string = 'dropdownOptionSelected';

    constructor(textOptionSelected: string, optionSelected: string) {
        super(DropdownOptionSelectedEvent.type,
            {
                detail: {
                    textOptionSelected: textOptionSelected,
                    optionSelected: optionSelected
                },
                bubbles: true
            });
    }
}

const bodyElement = document.querySelector('body');
const dropdownElements = document.querySelectorAll('.js-trovit-toggle-dropdown');
const dropdownSelectOptionElements = document.querySelectorAll('.js-trovit-select-dropdown-option');
const dropdownSelectOptionInputSelector: string = 'js-trovit-select-dropdown-option-input';
const eventBus = EventBus.getInstance();

dropdownElements.forEach((element) => {
    const dropdownElement = element as HTMLSelectElement;

    dropdownElement.addEventListener('click', function (event) {
        event.stopPropagation();
        dropdownElements.forEach((element) => {
            if (element.classList.contains('open') && element !== dropdownElement) {
                element.classList.remove('open');
            }
        });

        dropdownElement.classList.toggle('open');
    });

    if (bodyElement !== null) {
        bodyElement.addEventListener('click', function () {
            if (dropdownElement.classList.contains('open')) {
                dropdownElement.classList.toggle('open');
            }
        });
    }

    dropdownElement.addEventListener(DropdownOptionSelectedEvent.type, function (event) {
        const dropdownOptionSelectedEvent = event as DropdownOptionSelectedEvent;
        const selectedOption = dropdownElement.querySelector('.option-selected .text') as HTMLElement;
        const textOptionSelected: string = dropdownOptionSelectedEvent.detail.textOptionSelected;
        const optionSelected: string = dropdownOptionSelectedEvent.detail.optionSelected;

        if (selectedOption) {
            selectedOption.textContent = textOptionSelected;
        }

        const dropdownOptionInput = dropdownElement.querySelector<HTMLInputElement>(`#${dropdownElement.id} .${dropdownSelectOptionInputSelector}`);
        if (dropdownOptionInput) {
            dropdownOptionInput.value = optionSelected;
        }

        eventBus.emit(new SelectChangeEvent({
            id: dropdownElement.id,
            name: textOptionSelected,
            value: optionSelected
        }));
    });
});

dropdownSelectOptionElements.forEach((element) => {
    const dropdownSelectOptionElement = element as HTMLSelectElement;

    dropdownSelectOptionElement.addEventListener('click', function (event) {
        const optionSelected: string = dropdownSelectOptionElement.getAttribute("data-option")!!;
        const textOptionSelected: string = dropdownSelectOptionElement.textContent!!;

        dropdownSelectOptionElements.forEach((el) => {
            el.classList.remove('selected');
        });
        dropdownSelectOptionElement.classList.add('selected');

        const dropdownOptionSelectedEvent = new DropdownOptionSelectedEvent(textOptionSelected, optionSelected);
        dropdownSelectOptionElement.dispatchEvent(dropdownOptionSelectedEvent);
    });
});